import api from '../shared/AxiosConfig';

export const orderApi = {
    getAllOrders: () => api.get("/order"), // GET /api/order
    getOrderByGuid: (guid) => api.get(`/order/${guid}`),
    getPaginatedOrders: (page = 1, limit = 5) =>
        api.get(`/order/paginated?page=${page}&limit=${limit}`),
    cancelOrder: (orderGuid) => api.put(`/order/cancel-request/${orderGuid}`),
    requestRefund: (orderGuid) => api.post(`/order/refund-request/${orderGuid}`),

};
